// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {height: 100%;}
body {height: 100%;}
#root {height: 100%;}
.layout-logo {
  padding-left: 20px;
  color: #ffffff;
  display: flex;
  gap: 11px;
}
.ant-layout {
  background-color: #dee0e0;
  /* height: inherit; */
  height: 100%;
}
.ant-layout.layout-main {
  height: 100vh;
}
.layout-body {
}
.layout-sider {
  height: calc(100vh - 64px);
  background-color: #ffffff !important;
}
.side-container {
  overflow: auto;
  background-color: #ffffff;
}
.layout-content {
  background-color: #dee0e0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.layout-tab {
}
.layout-section {
  background-color: #dee0e0;
  display: flex;
  flex-direction: column;
  gap: 7px;
  width: 100%;
  height: calc(100% - (44px));

}
.layout-section2 {
  background-color: #dee0e0;
  /* padding: 14px 0px; */
  padding: 0px;
  height: calc(100vh - 130px)
}
.layout-section2 {
  background-color: #dee0e0;
  padding: 0px;
  height: calc(100% - 130px)
}
.layout-header {
  padding: 0px;
}
.layout-header-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.layout-header-submenu {
  padding-right: 20px;
  text-align: right;
  color: rgba(255, 255, 255, 0.70);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  .label-hq {
    color: #0257B5;
    font-weight: 600;
    line-height: 22px;
  }
  .label-branch {
    color: #008D05;
    font-weight: 600;
    line-height: 22px;
  }
  .label-school {
    color: #CE6F00;
    font-weight: 600;
    line-height: 22px;
  }
  .label-sptp {
    color: #D45252;
    font-weight: 600;
    line-height: 22px;
  }
  .label-post {
    color: #924EBA;
    font-weight: 600;
    line-height: 22px;
  }
}
.layout-nav {
  height: 44px;
  padding: 12px;
  /* height: 52px;
  padding: 16px; */
  /* height: 66px;
  padding: 24px 24px 20px 24px; */
  background-color: #ffffff;
}
.layout-title {
  height: 24px;
  padding-left: 2px;
  display: flex;
  align-items: center;
}
.layout-title-label {
  font-size: 1.4rem;
}
.layout-subtitle {
  font-size: 1.4rem;
}
.title-bar {
  display: block;
  width: 4px;
  height: 20px;
  background-color: var(--color-qmir-navy);
}
.divider {
  border-width: 0px;
  margin: 10px 0px;
}
.divider-small {
  border-width: 0px;
  margin: 2px 0px;
}
.divider-vertical {
  border: 1px solid red;
  height: 100%;
}
.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer-container {
  background-color: rgb(222, 224, 224);
  color: #333;
  padding: 20px;
}
.footer-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.footer-logo {
  width: 50px; 
}
.footer-text {
  text-align: left;
  font-size: 14px;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/layout.css"],"names":[],"mappings":"AAAA,MAAM,YAAY,CAAC;AACnB,MAAM,YAAY,CAAC;AACnB,OAAO,YAAY,CAAC;AACpB;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;AACA;AACA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;AACA;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,2BAA2B;;AAE7B;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,aAAa;EACb;kBACgB;EAChB;iCAC+B;EAC/B,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,WAAW;EACX,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["html {height: 100%;}\r\nbody {height: 100%;}\r\n#root {height: 100%;}\r\n.layout-logo {\r\n  padding-left: 20px;\r\n  color: #ffffff;\r\n  display: flex;\r\n  gap: 11px;\r\n}\r\n.ant-layout {\r\n  background-color: #dee0e0;\r\n  /* height: inherit; */\r\n  height: 100%;\r\n}\r\n.ant-layout.layout-main {\r\n  height: 100vh;\r\n}\r\n.layout-body {\r\n}\r\n.layout-sider {\r\n  height: calc(100vh - 64px);\r\n  background-color: #ffffff !important;\r\n}\r\n.side-container {\r\n  overflow: auto;\r\n  background-color: #ffffff;\r\n}\r\n.layout-content {\r\n  background-color: #dee0e0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n}\r\n.layout-tab {\r\n}\r\n.layout-section {\r\n  background-color: #dee0e0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 7px;\r\n  width: 100%;\r\n  height: calc(100% - (44px));\r\n\r\n}\r\n.layout-section2 {\r\n  background-color: #dee0e0;\r\n  /* padding: 14px 0px; */\r\n  padding: 0px;\r\n  height: calc(100vh - 130px)\r\n}\r\n.layout-section2 {\r\n  background-color: #dee0e0;\r\n  padding: 0px;\r\n  height: calc(100% - 130px)\r\n}\r\n.layout-header {\r\n  padding: 0px;\r\n}\r\n.layout-header-menu {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.layout-header-submenu {\r\n  padding-right: 20px;\r\n  text-align: right;\r\n  color: rgba(255, 255, 255, 0.70);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 6px;\r\n  .label-hq {\r\n    color: #0257B5;\r\n    font-weight: 600;\r\n    line-height: 22px;\r\n  }\r\n  .label-branch {\r\n    color: #008D05;\r\n    font-weight: 600;\r\n    line-height: 22px;\r\n  }\r\n  .label-school {\r\n    color: #CE6F00;\r\n    font-weight: 600;\r\n    line-height: 22px;\r\n  }\r\n  .label-sptp {\r\n    color: #D45252;\r\n    font-weight: 600;\r\n    line-height: 22px;\r\n  }\r\n  .label-post {\r\n    color: #924EBA;\r\n    font-weight: 600;\r\n    line-height: 22px;\r\n  }\r\n}\r\n.layout-nav {\r\n  height: 44px;\r\n  padding: 12px;\r\n  /* height: 52px;\r\n  padding: 16px; */\r\n  /* height: 66px;\r\n  padding: 24px 24px 20px 24px; */\r\n  background-color: #ffffff;\r\n}\r\n.layout-title {\r\n  height: 24px;\r\n  padding-left: 2px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.layout-title-label {\r\n  font-size: 1.4rem;\r\n}\r\n.layout-subtitle {\r\n  font-size: 1.4rem;\r\n}\r\n.title-bar {\r\n  display: block;\r\n  width: 4px;\r\n  height: 20px;\r\n  background-color: var(--color-qmir-navy);\r\n}\r\n.divider {\r\n  border-width: 0px;\r\n  margin: 10px 0px;\r\n}\r\n.divider-small {\r\n  border-width: 0px;\r\n  margin: 2px 0px;\r\n}\r\n.divider-vertical {\r\n  border: 1px solid red;\r\n  height: 100%;\r\n}\r\n.flex-center {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.footer-container {\r\n  background-color: rgb(222, 224, 224);\r\n  color: #333;\r\n  padding: 20px;\r\n}\r\n.footer-content {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 20px;\r\n}\r\n.footer-logo {\r\n  width: 50px; \r\n}\r\n.footer-text {\r\n  text-align: left;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
